import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  type GetWashboardDeviceDetailsResponse,
  type WashboardDeviceDetails,
  getWashboardDeviceDetails,
} from 'api/admin/washboard/washboard';

export const FIRMWARE_UPDATE_POLL_INTERVAL_MS = 15_000;

export const useWashboardDeviceDetails = (
  deviceId: number,
  onError?: (error: unknown) => void,
): {
  data?: WashboardDeviceDetails;
  isLoading: boolean;
  refetch: () => void;
} => {
  const errorHandler = (error: unknown) => {
    Sentry.captureException(error);
    onError?.(error);
  };

  const result = useQuery({
    queryKey: ['washboardDeviceDetails', deviceId],
    queryFn: async () => {
      const { data } = (await getWashboardDeviceDetails(
        deviceId,
      )) as AxiosResponse<GetWashboardDeviceDetailsResponse>;

      return data.device;
    },
    onError: errorHandler,
    retry: 1,
    enabled: !!deviceId,
    refetchInterval: FIRMWARE_UPDATE_POLL_INTERVAL_MS,
    refetchOnWindowFocus: false,
  });

  return {
    data: result.data,
    isLoading: result.isLoading,
    refetch: result.refetch,
  };
};
